exports.ByName = {
  InitialAverage: { Id: 1, Name: 'range_type.initial_average' },
  FinalAverage: { Id: 2, Name: 'range_type.final_average' },
  Projection: { Id: 3, Name: 'range_type.projection' },
  InitialYearly: { Id: 4, Name: 'range_type.initial_yearly' },
  FinalYearly: { Id: 5, Name: 'range_type.final_yearly' }
};

exports.ById = {
  1: { Id: 1, Name: 'range_type.initial_average' },
  2: { Id: 2, Name: 'range_type.final_average' },
  3: { Id: 3, Name: 'range_type.projection' },
  4: { Id: 4, Name: 'range_type.initial_yearly' },
  5: { Id: 5, Name: 'range_type.final_yearly' }
};
